import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d327c26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-drawer-container absolute inset-y-0 right-0 bg-white pl-5 pr-1 pt-8 flex flex-col flex-grow" }

import { defineAsyncComponent } from 'vue'
import { Chat } from '@/types/user-chat'

export default /*#__PURE__*/_defineComponent({
  props: {
    chat: null
  },
  setup(__props: any) {

const DrawerSingle = defineAsyncComponent(() => import('./DrawerSingle.vue'))
const DrawerGroup = defineAsyncComponent(() => import('./DrawerGroup.vue'))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.chat.type === 'single')
      ? (_openBlock(), _createBlock(_unref(DrawerSingle), {
          key: 0,
          "user-address": __props.chat.id
        }, null, 8, ["user-address"]))
      : (_openBlock(), _createBlock(_unref(DrawerGroup), {
          key: 1,
          "host-id": __props.chat.id.hostId,
          "group-id": __props.chat.id.groupId
        }, null, 8, ["host-id", "group-id"]))
  ]))
}
}

})